import React from 'react'
import { Navigate } from 'react-router-dom'
import Store from 'store'

const isAuthenticated = () => {
  return !!Store.get('aff-tok')
}

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />
  }
  return <>{children}</>
}

export default ProtectedRoute
